import React, { useCallback, useRef } from "react";
import { List } from "../../Components/common/List/List";
import { ListProvider } from "../../Components/common/List/Providers/List";
import { useParams } from "react-router-dom";
import { Parcel } from "../../Models/Parcel";
import { ParcelListItem } from "./ParcelListItem";
import { useListProps } from "./utilities/List";
import { ParcelHeader } from "./ParcelHeader";
import { ParcelFooter } from "./ParcelFooter";

const AnyListProvider = ListProvider as any;
const AnyList = List as any;

export const ParcelsIndex: React.FC = () => {
  const listRef = useRef<{ refresh: () => void } | null>(null);
  const { id } = useParams<{ id: string }>();
  const listProps = useListProps(id);

  const renderHeader = useCallback(() => {
    return <ParcelHeader />;
  }, []);

  const renderItem = useCallback((item: Parcel, index: number) => {
    return <ParcelListItem listRef={listRef} item={item} index={index} />;
  }, []);

  const renderFooter = useCallback(() => {
    return <ParcelFooter />;
  }, []);

  return (
    <>
      <AnyListProvider path={listProps.path} filters={listProps.filters}>
        <AnyList
          renderItem={renderItem}
          pagination={listProps.pagination}
          actionBar={listProps.actionBar}
          selectRowsEnabled={listProps.selectRowsEnabled}
          renderHeader={renderHeader}
          renderFooter={renderFooter}
        />
      </AnyListProvider>
    </>
  );
};
